/**
 * uni-app公共环境变量设置
 */
;(function() {
    const env = process.env.NODE_ENV; // 直接读取真实环境
    let ENV_VAR = null;

    if (env === 'development') {
        ENV_VAR = require('./.env.dev.js');
    } else if (env === 'test') {
        ENV_VAR = require('./.env.test.js');
    } else if (env === 'production') {
        ENV_VAR = require('./.env.prod.js');
    }

    if (ENV_VAR) {
        process.uniEnv = {};
        for (let key in ENV_VAR) {
            process.uniEnv[key] = ENV_VAR[key];
        }
    }
})();